import React from 'react';
import loader from "../../assets/loader.gif"

const Loading = () => {
  return (
    <div
      className={`w-full h-full flex justify-center items-center`}
    >
      <img src={loader} alt={''} width={200} />
    </div>
  );
};

export default Loading;
